var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContact4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.6673 19.9999C36.6673 10.7999 29.2007 3.33325 20.0007 3.33325C10.8007 3.33325 3.33398 10.7999 3.33398 19.9999C3.33398 28.0666 9.06732 34.7833 16.6673 36.3332V24.9999H13.334V19.9999H16.6673V15.8333C16.6673 12.6166 19.284 9.99992 22.5007 9.99992H26.6673V14.9999H23.334C22.4173 14.9999 21.6673 15.7499 21.6673 16.6666V19.9999H26.6673V24.9999H21.6673V36.5833C30.084 35.7499 36.6673 28.6499 36.6673 19.9999Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContact4);
export default __webpack_public_path__ + "static/media/contact4.92313d54a6954cc1273d22030801f1f4.svg";
export { ForwardRef as ReactComponent };